import {
  SiZoom,
  SiShopify,
  SiWordpress,
  SiNotion,
  SiMailchimp,
  SiGooglemeet,
  SiJira,
} from 'react-icons/si';
import { MessageSquare, Mail, Users, Layout } from 'lucide-react';

const tools = [
  { name: 'Slack', icon: MessageSquare, color: '#4A154B' },
  { name: 'Zoom', icon: SiZoom, color: '#2D8CFF' },
  { name: 'Shopify', icon: SiShopify, color: '#96BF48' },
  { name: 'WordPress', icon: SiWordpress, color: '#21759B' },
  { name: 'Notion', icon: SiNotion, color: '#000000' },
  { name: 'Mailchimp', icon: SiMailchimp, color: '#FFE01B' },
  { name: 'Kit', icon: Mail, color: '#FB4C1F' },
  { name: 'Google Meet', icon: SiGooglemeet, color: '#00897B' },
  { name: 'Microsoft Teams', icon: Users, color: '#6264A7' },
  { name: 'Jira Software', icon: SiJira, color: '#0052CC' },
  { name: 'Monday', icon: Layout, color: '#F02D65' },
];

export default function Ecosystem() {
  return (
    <section className="bg-slate-50 py-24" aria-labelledby="ecosystem-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center">
          <h2 id="ecosystem-heading" className="section-title">
            Connect your ecosystem. <span className="text-brand-700">Your way.</span>
          </h2>
          <p className="section-subtitle mx-auto mt-4 max-w-2xl">
            Zuri Hub works with the tools your team already uses. Sync conversations, tickets, and customer context across your favorite stack.
          </p>
        </div>
        <div className="mx-auto grid max-w-5xl grid-cols-2 gap-6 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
          {tools.map((tool) => {
            const Icon = tool.icon;
            return (
              <div
                key={tool.name}
                className="group flex flex-col items-center justify-center gap-3 rounded-2xl border border-slate-200 bg-white p-6 text-center shadow-sm transition hover:-translate-y-1 hover:shadow-lg"
              >
                <Icon className="h-9 w-9 transition group-hover:scale-110" style={{ color: tool.color }} />
                <span className="text-sm font-bold text-slate-700">{tool.name}</span>
              </div>
            );
          })}
        </div>
        <div className="mt-10 text-center">
          <a href="/integrations" className="inline-flex items-center gap-2 rounded-full bg-slate-900 px-6 py-2.5 text-sm font-bold text-white transition hover:bg-slate-800">
            View all integrations
          </a>
        </div>
      </div>
    </section>
  );
}
